import { CSSProperties } from 'react';
import { Loader } from '@mantine/core';
import clsx from 'clsx';

import styles from './loading-indicator.module.scss';

export type LoadingIndicatorProps = {
  className?: string;
  'data-testid'?: string;
  style?: CSSProperties;
  /** css size value, e.g. 1em */
  size?: string;
};

export function LoadingIndicator({
  className,
  'data-testid': testId,
  size = '1em',
  style,
}: LoadingIndicatorProps) {
  return (
    <Loader
      classNames={{ root: clsx(styles['loading-indicator'], className) }}
      color="rgb(var(--portal-ui-color-grey-2))"
      data-testid={testId}
      size={size}
      style={style}
      type="oval"
    />
  );
}
